import React from 'react';
import ToggleButton from '../ToggleButton';
import { useAppDispatch, useAppSelector, useAppStore } from '@/lib/hooks';
import { setAdminStudentView } from '@/lib/slices/course-slice';
import { resetActivitySlice } from '@/lib/slices/activity-slice';
import { setUnitId } from '@/lib/slices/unit-slice';
import { setSubunitId } from '@/lib/slices/subunit-slice';

export function AdminStudentViewToggle(): React.JSX.Element {
  const dispatch = useAppDispatch();
  const store = useAppStore();

  const { adminStudentView } = useAppSelector(() => store.getState().course);

  const resetAdminStudentViewState = () => {
    dispatch(resetActivitySlice());
    dispatch(setSubunitId(undefined));
    dispatch(setUnitId(''));
  };

  return (
    <div className='flex items-center gap-2'>
      <span className={`${adminStudentView ? 'font-semibold' : ''} text-sm`}>Student View</span>
      <ToggleButton
        onClick={() => {
          const next = !adminStudentView;
          dispatch(setAdminStudentView(next));
          if (!next) {
            resetAdminStudentViewState();
          }
        }}
        displayIcons={false}
        initialState={adminStudentView}
      />
    </div>
  );
}
